import React from 'react';
import { getKey, getParam } from 'utils';
import Icon from './icon';

let noTopbar = getParam('no-topbar');

export default ({
  icon = '',
  title = '',
  subTitle = '',
  deleteAction,
  editAction,
  actionButtons = [], // {icon, onClick}
}) => {
  noTopbar = noTopbar || getKey('isAccessByDCD');

  return (
    <div className="strap" style={{ margin: '-11px -10px 15px -20px', padding: '15px 25px' }}>
      {noTopbar && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Icon
            name="chevron-left"
            onClick={() => window.history.back()}
            style={{
              fontSize: 18, paddingRight: 20, color: 'var(--color-base)', cursor: 'pointer',
            }}
          />
        </div>
      )}

      <div className="strap-details">
        {!!icon && <Icon name={icon} style={{ fontSize: 30, color: 'var(--color-base)' }} />}

        <div>
          <span style={{ display: 'block', marginLeft: 10 }} className="strap-details-title">
            {title}
          </span>
          <span
            style={{
              display: 'flex',
              fontSize: 12,
              justifyItems: 'center',
              marginLeft: 10,
            }}
          >
            {subTitle}
          </span>
        </div>
      </div>
      <div className="strap-details-icons">
        {!!deleteAction && (
          <Icon
            name="trash"
            className="delete"
            onClick={deleteAction}
          />
        )}

        {!!editAction && (
          <Icon
            name="edit"
            className="edit"
            onClick={editAction}
          />
        )}

        {actionButtons.map(({ icon: iconName = '', onClick }) => (
          <Icon
            name={iconName}
            className="edit"
            onClick={onClick}
          />
        ))}
      </div>
    </div>
  );
};
